import driverAuthBearer from "./authBearer";
import driverHttpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js";
import driverRouterVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js";

// Auth base configuration some of this options
// can be override in method calls
const DRIVERS = {
  auth: driverAuthBearer,
  http: driverHttpAxios,
  router: driverRouterVueRouter,
};

const OPTIONS = {
  rolesKey: "roles",
  notFoundRedirect: { name: "Options" },
  tokenDefaultKey: "token",
  refreshTokenName: "refreshToken",
  tokenStore: ["localStorage"],
  refreshData: {
    enabled: true,
    url: "/api/token/refresh",
    interval: 19,
    method: "POST",
  },
  fetchData: { url: "/api/Users/current", enabled: true },
  authRedirect: "/authentication/login",
  parseUserData(data) {
    return data || {};
  },
  loginData: {
    url: "/api/login",
    method: "POST",
    redirect: false,
    fetchUser: true,
  },
  logoutData: {
    url: "/api/logout",
    method: "POST",
    redirect: "/authentication/login",
    fetchUser: false,
  },
};

export { DRIVERS, OPTIONS };
